import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const NotesHeader = styled.header`
  display: flex;
`

export const BadgeWrapper = styled.div``

export const ClosePanelIconWrapper = styled.figure`
  margin-top: -${Spacing.S8};
  margin-right: -${Spacing.S16};
  margin-left: auto;
`
